<template>
    <b-row class="results-content-simulacro mt-3">
        <b-row class="results-content-simulacro-border">
            <b-col cols="12" lg="8" class="results-content-simulacro-center">
                <b-row style="margin-bottom: -0.5rem;">
                    <b-col  cols="12">
                        <p class="results-title-simulacro">{{item.nombre | upper}}</p>
                    </b-col>
                </b-row>
                <b-row >
                    <b-col  cols="12" lg="4" >
                        <p class="results-title-key">Key de acceso: {{ item.key }} </p>
                    </b-col>
                    <b-col  cols="12" lg="4" class="ml-5">
                        <p class="results-title-key">{{ item.desde  }}</p>
                    </b-col>
                    <b-col  cols="12" lg="4">
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" lg="3" class="ml-5">
                <b-row>
                    <button class="button-primary-result" @click="goRouter(content.button1.url, item)">
                        <span class="button-text-result">{{ content.button1.name }}</span>
                    </button>
                </b-row>
                <b-row>
                    <button class="button-primary-result" @click="goRouter(content.button2.url, item)">
                        <span class="button-text-result">{{ content.button2.name }}</span>
                    </button>
                </b-row>
            </b-col>
        </b-row>
    </b-row>
</template>
<script>
    export default {
        name: 'Results',
        props: {
            id: Number,
            item: Object,
            filterKey: String,
            content: Object
        },
        methods: {
            goRouter(url, item) {
                this.$store.dispatch("setKey", item.key);
                this.$store.dispatch("setKeyData", item);
                this.$router.push(url)
          

            }
        },
        filters:{
            upper(value){
                return value.toUpperCase()
            }
        }
    }
</script>
<style scoped>

</style>
